<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ConditionWrapper',
  props: {
    disabled: false
  },
  provide() {
    return {
      elForm: this
    }
  }
}
</script>
